/*
*
 Tekið temporarilly af https://github.com/islenska-org/icelandic/blob/master/src/alphabetical.js
*
*/
const alphabetIndex = {};
// Icelandic sorts lowercase before uppercase
' -.,0123456789aábcdðeéfghiíjklmnoópqrstuúvwxyýzþæö'
  .split('')
  .forEach((d, i) => {
    alphabetIndex[d] = i + 1;
    if (d.toUpperCase() !== d) {
      alphabetIndex[d.toUpperCase()] = i + 1;
    }
  });

/* eslint-disable */
export default function islSort(a, b) {
  // null handling
  if (a === null) {
    return 1;
  } else if (b === null) {
    return -1;
  }

  // same word? exit early
  const al = a.length;
  const bl = b.length;
  if (al === bl && a === b) {
    return 0;
  }
  // char by char evaluation
  const l = Math.min(al, bl);
  let c = -1;
  while (++c < l) {
    const aV = alphabetIndex[a[c]];
    const bV = alphabetIndex[b[c]];
    // because alphabetIndex has a 1 based index, any falsy value means "undefined" character
    if (!aV || !bV) {
      // either char is not defined: we can JS sort them
      return a[c] < b[c] ? -1 : a[c] > b[c] ? 1 : 0;
    } else if (aV !== bV) {
      // it's not the same char, go by value
      return aV - bV;
    }
  }
  // words are not identical but didn't sort: this must be the same word but casing is different!
  if (al === bl) {
    return a > b ? -1 : a < b ? 1 : 0;
  }
  // words are not identical, so the longer one is the shorter+suffix
  return al - bl;
}
/* eslint-enable */
